module.exports = __webpack_public_path__ + "static/media/BigHat.43f91665.jpeg";